import { render, staticRenderFns } from "./DoctorTargetList.vue?vue&type=template&id=4be7cb4d&scoped=true"
import script from "./DoctorTargetList.vue?vue&type=script&lang=js"
export * from "./DoctorTargetList.vue?vue&type=script&lang=js"
import style0 from "./DoctorTargetList.vue?vue&type=style&index=0&id=4be7cb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7cb4d",
  null
  
)

export default component.exports